export const PAGE_SIZE_OPTS = [10, 20, 30, 40];
